<template>
  <mobile-multiselect-item
    v-on="$listeners"
    v-bind="$attrs"
    :is-selected="isSelected"
  >
    <color-select-option
      :color="color"
      :is-selected="isSelected"
    />
  </mobile-multiselect-item>
</template>

<script>
import MobileMultiselectItem from '@/components/mobile-multiselect/mobile-multiselect-item.vue';
import ColorSelectOption from '@kit/color-select-option/color-select-option.vue';

export default {
  components: {
    MobileMultiselectItem,
    ColorSelectOption,
  },

  props: {
    color: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
  },
}
</script>